<template>
    <div v-if="user.name" class="profile-name" @click="navigateToHome()" :style="{cursor:'pointer'}">
        {{ user.name }}
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "UserName",
        computed: {
            ...mapGetters("view", ["viewData"]),
            user() {
                return this.viewData.user
            },
            portfolio() {
                return this.viewData.portfolio
            }
        },
        methods: {
            navigateToHome() {
                if(this.portfolio.ownDomainAddress) {
                    this.$router.push('/')
                }
                else {
                    this.$router.push('/' + this.portfolio.shortId)
                }
            }
        }
    }
</script>